import { render, staticRenderFns } from "./ViewDownloadFormsPopup.vue?vue&type=template&id=6a0e2334&scoped=true"
import script from "./ViewDownloadFormsPopup.vue?vue&type=script&lang=js"
export * from "./ViewDownloadFormsPopup.vue?vue&type=script&lang=js"
import style0 from "./ViewDownloadFormsPopup.vue?vue&type=style&index=0&id=6a0e2334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0e2334",
  null
  
)

export default component.exports